/** Mensajes según lockReason de PATCH Orders/isEditable */
export const ORDER_LOCK_MESSAGES = {
  PaymentApproved:
    "Tu suscripción ha sido pagada y está siendo procesada",
  MercadoPagoPending:
    "Tenés un pago en Mercado Pago en proceso. Esperá la confirmación para continuar.",
  ChurchCampaignClosed:
    "Tu iglesia cerró la campaña de suscripción de este período.",
  PeriodNotStarted: "El período de suscripción aún no comenzó.",
  PeriodEnded: "El período de suscripción finalizó.",
  CustomerPeriodEnded:
    "Finalizó el plazo para realizar suscripciones en este período.",
  PeriodUnavailable: "No hay un período de suscripción activo.",
  ActiveOrderExists:
    "Ya tenés un pedido activo. Finalizá o pagá ese pedido antes de crear uno nuevo.",
};

const SUCCESS_REASONS = new Set(["PaymentApproved"]);
const WARNING_REASONS = new Set(["MercadoPagoPending", "ChurchCampaignClosed", "ActiveOrderExists"]);
const ERROR_REASONS = new Set([
  "PeriodNotStarted",
  "PeriodEnded",
  "CustomerPeriodEnded",
  "PeriodUnavailable",
]);

export function messageForLockReason(lockReason) {
  if (!lockReason) return null;
  return ORDER_LOCK_MESSAGES[lockReason] || null;
}

export function bannerVariantForLockReason(lockReason) {
  if (!lockReason) return null;
  if (SUCCESS_REASONS.has(lockReason)) return "success";
  if (ERROR_REASONS.has(lockReason)) return "error";
  if (WARNING_REASONS.has(lockReason)) return "warning";
  return "warning";
}

/** Aplica campos de PATCH Orders/isEditable sobre refs de Vue. */
export function applyIsEditableFromResponse(
  { isEditable, orderId, lockReason, total },
  data
) {
  isEditable.value = data.isEditable;
  orderId.value = data.orderId;
  lockReason.value = data.lockReason || null;
  if (total) {
    total.value = data.total;
  }
}
